(function () {
  "use strict";

  angular
    .module("alk.maps")
    .factory("savedMapInfo", savedMapInfo);
  savedMapInfo.$inject = ["$rootScope", "$location", "ALKMaps", "UserProvider", "mapUtilities"];

  function savedMapInfo($rootScope, $location, ALKMaps, UserProvider, mapUtilities) {
    var mapElem = {};

    var service = {
      getSavedInfo: getSavedInfo,
      saveCurrentInfo: saveCurrentInfo,
      getSavedInfoAsUrl: getSavedInfoAsUrl
    };

    $rootScope.$on("UserLoggedIn", function () {
      mapElem.savedInfo = null;
    });

    $rootScope.$on("releaseMap", function (event, data) {
      mapElem = mapElem || {};
      mapElem.savedInfo = mapElem.savedInfo || {};
      mapElem.savedInfo.mapCenter = data.center;
      mapElem.savedInfo.mapZoom = data.zoom;
      mapElem.savedInfo.mapStyle = data.style;
    });

    return service;

    function getSavedInfoAsUrl() {
      var savedInfo = getSavedInfo();
      var precision = Math.max(0, Math.ceil(Math.log(savedInfo.mapZoom) / Math.LN2));
      var center = angular.copy(savedInfo.mapCenter).transform(new ALKMaps.Projection("EPSG:900913"), new ALKMaps.Projection("EPSG:4326"));
      var urlCenterParam = [savedInfo.mapZoom, center.lat.toFixed(precision), center.lon.toFixed(precision)].join(",");
      return urlCenterParam;
    }

    function saveCurrentInfo(center, zoom, style) {
      mapElem = mapElem || {};
      mapElem.savedInfo = mapElem.savedInfo || {};
      mapElem.savedInfo.mapCenter = center;
      mapElem.savedInfo.mapZoom = zoom;
      mapElem.savedInfo.mapStyle = style;
    }

    function getSavedInfo() {
      if (mapElem.savedInfo)
        return mapElem.savedInfo;

      var zoom;
      var center;
      var urlCenter = mapUtilities.parseCenterParams($location.search());
      var couldTryGeolocating = false;
      if (urlCenter) {
        center = mapUtilities.LLtoMerc(urlCenter.center[0], urlCenter.center[1]);
        zoom = urlCenter.zoom;
      } else {
        // initial location of map is based on the region the user is setup for currently. in the future if the user has access to world wide, use the location of the browser possibly?
        if (UserProvider.getUser().region === "EU") {
          center = mapUtilities.LLtoMerc(8.403, 47.875);
          zoom = 5;
        } else {
          center = mapUtilities.LLtoMerc(-95, 38.5);
          zoom = 5;
        }

        //  if there is no saved info, and we had to fallback to just a default lat/lon for a region,
        //  then it is up to the app to choose if they want to geolocate instead.
        couldTryGeolocating = true;
      }

      return {
        mapCenter: center,
        mapStyle: ALKMaps.STYLE.DEFAULT,
        mapZoom: zoom,
        couldTryGeolocating: couldTryGeolocating
      };
    }

  }
})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-maps/map.savedInfo.js